import { render, staticRenderFns } from "./BasicHeader.vue?vue&type=template&id=7082c522&scoped=true"
import script from "./BasicHeader.vue?vue&type=script&lang=js"
export * from "./BasicHeader.vue?vue&type=script&lang=js"
import style0 from "./BasicHeader.vue?vue&type=style&index=0&id=7082c522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_65b20228bf64a20fbf49a510659098cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7082c522",
  null
  
)

export default component.exports